import FatalErrorModal from 'components/FatalErrorModal';
import ModuleNotLoadedError from 'components/ModuleNotLoadedError';

export const mfeLazyLoadErrorHandler = (e: any) => {
  // eslint-disable-next-line
  console.error(e);
  return Promise.resolve({ default: ModuleNotLoadedError });
};

export const mfeLazyLoadFatalErrorHandler = (e: any) => {
  // eslint-disable-next-line
  console.error(e);
  return Promise.resolve({ default: FatalErrorModal });
};
